/**
 * 业务错误码常量
 * 用于登录、注册等业务场景的错误码定义
 */

/** 用户未登录 */
export const USER_NOT_LOGIN = 920001;

/** 用户未注册 */
export const UNREGISTERED_CODE = 110008;

/** 用户名已存在 */
export const USER_NAME_EXISTS = 100005;

/** 验证码错误（邮箱注册） */
export const EMAIL_CODE_ERROR = 110003;

/** 验证码错误（密码重置） */
export const VERIFY_CODE_ERROR = 110003;

/** 验证码已过期 */
export const VERIFY_CODE_EXPIRE = 110002;

/** 每分钟请求次数超限 */
export const MIN_REQ_EXCEEDS_LIMIT = 110000;
